export const REQUEST = 'Smtps/REQUEST';
export const SUCCESS = 'Smtps/SUCCESS';
export const ERROR = 'Smtps/ERROR';

export const SET = 'Smtps/SET';
export const DELETED = 'Smtps/DELETED';
export const UPDATED = 'Smtps/UPDATED';
export const ADDED = 'Smtps/ADDED';